export function getRandInt() {
    return randomIntInclusive(10000, 999999)
}

export function getPosRandInt() {
    return randomIntInclusive(-999999, -10000)
}

export function randomIntInclusive(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
}